import React from "react";
import { commonStyles } from "../assets/css/commonStyle";
import { fontFamilyStyles } from "../assets/css/commonFontStyles";
import { StyleSheet, View, Text } from "../core";
import { customCommonStyles } from "../assets/css/customCommonStyle";
import { uberDocThemeStyle } from "../assets/css/clients/uberDocThemeStyle";

export default class NoRecordsFound extends React.Component {
  render() {
    const { message, noRecords, isUberDocs } = this.props;
    let clientStyle = !!isUberDocs ? uberDocThemeStyle : commonStyles;
    let commonFontStyles = !!isUberDocs ? uberDocThemeStyle : fontFamilyStyles;
    return (
      <View style={[styles.nofoundmsg, commonStyles.flex1, commonStyles.flexGrow0, customCommonStyles.customNoRecordsFound, noRecords]}>
        <Text style={[commonFontStyles.workSans, commonStyles.paragraphTextHeader, clientStyle.contentColor]}>{message}</Text>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  nofoundmsg: {
    backgroundColor:"#f5f5f5",
    padding: 10,
    paddingTop: 6,
    paddingBottom: 6,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    margin: 15,
    marginTop: 10,
    marginBottom: 10,
  },
});
